import gql from '@zenbusiness/application-commons-utils/gql';

export const BANKING_ELIGIBILITY_CHECK = gql`
  query BankingEligibilityCheck($input: EligibleBankingInput!) {
    bankingEligibilityCheck(input: $input) {
      bankingEligibilityStatus
    }
  }
`;
